import { StrictMode } from 'react';

import { Toaster } from '@cuc/ui/kit';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { AuthProvider } from 'react-oidc-context';
import { BrowserRouter } from 'react-router';

import { createOidcConfig } from '@/features/auth';
import type { RuntimeConfig } from '@/shared/config';

import { App, ErrorBoundary } from '../entrypoint';

import { queryClient } from './queryClient';

import '../styles/index.css';

type AppProvidersProps = {
  config: RuntimeConfig;
};

export function AppProviders({ config }: AppProvidersProps) {
  return (
    <StrictMode>
      <AuthProvider {...createOidcConfig(config)}>
        <BrowserRouter>
          <QueryClientProvider client={queryClient}>
            <ErrorBoundary>
              <App />

              <Toaster />
              <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" />
            </ErrorBoundary>
          </QueryClientProvider>
        </BrowserRouter>
      </AuthProvider>
    </StrictMode>
  );
}
